import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuth from "../../hooks/useAuth";
import { getBottomNavItems } from "../../config/menuConfig";

// ─────────────────────────────────────────────────────────────────────────────
// BottomNavigation — barra inferior fija en mobile.
//
// Layout: 4 ítems por rol + un quinto "Más" (action="openDrawer") que dispara
// onOpenDrawer en vez de navegar. Así, todo el resto del menú permanece
// accesible aunque el sidebar esté oculto en mobile.
// ─────────────────────────────────────────────────────────────────────────────
const BottomNavigation = ({ onOpenDrawer }) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const baseItems = getBottomNavItems(user?.role);
  if (!baseItems.length) return null;

  // Tope: 4 ítems "reales" + "Más" (5to slot). Si el rol ya devuelve menos
  // de 4, igual se agrega "Más" al final.
  const visible = baseItems.slice(0, 4);
  const items = [
    ...visible,
    { label: "Más", icon: "menu", action: "openDrawer" },
  ];

  const isActive = (item) => {
    if (item.action === "openDrawer") return false;
    if (item.path === "/admin") return pathname === "/admin" || pathname === "/admin/";
    if (item.path === "/home") return pathname === "/home" || pathname === "/home/";
    return pathname === item.path || pathname.startsWith(item.path + "/");
  };

  const handleClick = (item) => {
    if (item.action === "openDrawer") {
      if (typeof onOpenDrawer === "function") onOpenDrawer();
      return;
    }
    navigate(item.path);
  };

  return (
    <nav className="bottom-nav" aria-label={t("Navegación principal móvil")}>
      {items.map((item, idx) => {
        const active = isActive(item);
        const label = t(item.label);
        return (
          <button
            key={item.path || `action-${item.action}-${idx}`}
            className={`bottom-nav__item${active ? " active" : ""}`}
            onClick={() => handleClick(item)}
            type="button"
            aria-label={label}
            aria-current={active ? "page" : undefined}
          >
            <span className="material-symbols-outlined bottom-nav__icon" aria-hidden="true">
              {item.icon}
            </span>
            <span className="bottom-nav__label">{label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNavigation;
